// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2925":"180c7042b4e89912","5389":"5fba19b2bc9eda21"}[chunkId] + ".js";
};